import React from "react";
import Flex from "@/components/layout/Flex";
import Divider from "@/components/shared/Divider";
import Typography from "@/components/shared/Typography";
import { breakpointClasses, cls, cn, splitBreakpointProps } from "@/lib/utils";
import type { HeadlineProps } from "./types";

function Headline({
  as = "H2",
  className = "",
  wrapperClassName = "",
  dividerClassName = "",
  children,
  ...props
}: HeadlineProps) {
  const Component = Typography[as];
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Flex.Column
      data-slot="headline"
      className={cn(cls``, wrapperClassName)}
      items="start"
      {...native}
    >
      <Component className={cn(cls``, className, classes)}>
        {children}
      </Component>

      <Divider
        className={cn(cls`my-0 border-t-4 w-20`, dividerClassName)}
        color="border-primary"
      />
    </Flex.Column>
  );
}

Headline.DisplayName = "Headline";

export default Headline;
